const topicsData = [
  { name: '#明星恋情曝光', heat: '🔥 128.6万', trend: 'up', icon: 'ri-heart-line' },
  { name: '#综艺名场面', heat: '🔥 96.3万', trend: 'up', icon: 'ri-emotion-laugh-line' },
  { name: '#网红翻车现场', heat: '🔥 84.1万', trend: 'up', icon: 'ri-error-warning-line' },
  { name: '#影视穿帮镜头', heat: '⚡ 72.5万', trend: 'up', icon: 'ri-film-line' },
  { name: '#歌手抄袭争议', heat: '⚡ 68.9万', trend: 'hot', icon: 'ri-music-line' },
  { name: '#运动员退役生活', heat: '📈 55.7万', trend: 'up', icon: 'ri-run-line' },
  { name: '#短视频新规', heat: '📈 48.3万', trend: 'new', icon: 'ri-smartphone-line' },
  { name: '#八卦深度扒', heat: '📈 42.6万', trend: 'hot', icon: 'ri-search-eye-line' },
  { name: '#娱乐大事件', heat: '🆕 35.2万', trend: 'new', icon: 'ri-flashlight-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门话题</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            正在火热讨论的话题标签，点击探索更多精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {topicsData.map((topic, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-center gap-3 bg-background-100 border border-background-300/30 rounded-xl px-4 py-3.5 transition-all hover:border-primary-500/20 hover:bg-background-200/50 cursor-pointer"
            >
              <div className={`flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center ${
                idx % 3 === 0 ? 'bg-primary-500/10' : idx % 3 === 1 ? 'bg-accent-500/10' : 'bg-secondary-500/10'
              }`}>
                <i className={`${topic.icon} text-base ${
                  idx % 3 === 0 ? 'text-primary-400' : idx % 3 === 1 ? 'text-accent-400' : 'text-secondary-400'
                }`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-400 transition-colors block truncate">
                  {topic.name}
                </span>
              </div>
              <span className="flex-shrink-0 text-xs text-foreground-500 whitespace-nowrap">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}